import Switch from 'components/Switch';

export const BoostSwitch = ({
  disabled,
  replaceSwitchWithLoadingSpinner,
  boostJackpot,
  setBoostJackpot,
  onAnyUserAction = () => {},
  glowColor,
  onClickWhileDisabled,
}: {
  disabled?: boolean;
  replaceSwitchWithLoadingSpinner?: boolean;
  boostJackpot: boolean;
  setBoostJackpot: (boost: boolean) => void;
  onAnyUserAction?: () => void;
  glowColor?: string;
  onClickWhileDisabled?: () => void;
}) => {
  return (
    <div
      className="boostSwitch flexCentered"
      onClick={disabled ? onClickWhileDisabled : undefined}
    >
      <Switch
        disabled={disabled}
        glowColor={glowColor}
        design3
        enabled={!disabled && boostJackpot}
        onToggle={() => {
          if (replaceSwitchWithLoadingSpinner) return;
          onAnyUserAction();
          setBoostJackpot(!boostJackpot);
        }}
        style={{
          opacity: replaceSwitchWithLoadingSpinner ? 0.5 : 1.0,
          cursor:
            replaceSwitchWithLoadingSpinner || disabled ? 'default' : 'pointer',
        }}
        id={undefined}
        withoutFill={undefined}
        optionalSliderImage={undefined}
        customOnOffLabels={undefined}
      />

      <style jsx>
        {`
          :global(.boostJackpotSection .boostSwitch .switch) {
            font-size: 1.1rem;
            font-weight: 800;
            margin: 0;
          }

          .boostSwitch {
            display: flex;
            align-items: flex-start;
            justify-content: center;
          }
        `}
      </style>
    </div>
  );
};
